<template>
  <div :class="$style.root">
  </div>
</template>

<style module>

.root{
  position:relative;
  width:100%;
  height:100%;
}

.iframe{
  position:absolute;
  z-index: 0;
  border: 0;
  visibility: hidden;
}

.iframe.visible{
  visibility: visible;
  z-index: 1;
}

</style>

<script>
import urlAppend from 'append-query' ;

export default {

  props:{
    customerId:{
      type:String
    },

    Authorization:{
      type:String
    },

    url:{
      type:String
    }
  },

  computed:{

    src(){

      const {
        customerId,
        Authorization,
        url
      } = this ;

      if(
          customerId &&
          Authorization &&
          url
      ){

        return urlAppend(url , {
          Authorization,
          customerId
        }) ;
      }
    }
  },

  mounted(){

    const {
          body
        } = document,
        me = this,
        {
          src:url,
          $el:el,
          $style:styles
        } = me ;


    let iframeEl = body.querySelector(`iframe[data-url='${url}']`) ;

    if(!iframeEl){

      iframeEl = document.createElement('iframe') ;

      iframeEl.frameborder = '0',
          iframeEl.scrolling = 'no',
          iframeEl.src = url;
        iframeEl.allowfullscreen = true

      body.insertBefore(iframeEl , body.querySelector('#main').nextElementSibling) ;
    }

    const {
      dataset
    } = iframeEl ;

    dataset.url = url ;

    const {
      style,
      classList
    } = iframeEl;

    classList.add(styles.iframe) ;

    classList.add(styles.visible) ;

    me.$onResize = () => {

      const {
        x,
        y,
        width,
        height
      } = el.getBoundingClientRect() ;

      style.setProperty('top' , `${y}px`),
          style.setProperty('left' , `${x}px`),
          style.setProperty('width' , `${width}px`),
          style.setProperty('height' , `${height}px`) ;
    } ;

    me.$iframeEl = iframeEl ;

    window.addEventListener('resize' , me.$onResize) ;

    me.$onResize() ;

  },
  methods:{
    onC(){
      let case1 = document.getElementById("iframe1");
      if (this.fullscreen) {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        }
      } else {
        if (case1.requestFullscreen) {
          case1.requestFullscreen();
        } else if (case1.webkitRequestFullScreen) {
          case1.webkitRequestFullScreen();
        } else if (case1.mozRequestFullScreen) {
          case1.mozRequestFullScreen();
        } else if (case1.msRequestFullscreen) {
          // IE11
          case1.msRequestFullscreen();
        }
      }
    }
  },

  destroyed(){

    const me = this ;

    me.$iframeEl.classList.remove(me.$style.visible) ;

    window.removeEventListener('resize' , me.$onResize) ;
  }

}
</script>
